import { DuplicateModel } from './../models/DuplicateModel.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppService } from '../app.service';

@Injectable()
export class DuplicateMeepCardService extends AppService<DuplicateModel> {

  constructor(http: HttpClient) {
    super(http);
  }

  async generateDuplicate(meepCardNumber, creditCard, cvv) {
    const result = await this.postAsync(`CartaoCashlessNominal/GerarSegundaVia`, {
      Tag: meepCardNumber,
      CartaoCredito: creditCard,
      cvv
    });
    return result;
  }

  async getAmountForDuplicate(meepCardNumber: string) {
    const result = await this.getAsync(`CartaoCashlessNominal/BuscarLocalParaGerarSegundaVia/${meepCardNumber}`);
    return result;
  }

  async confirmDuplicate(newMeepCardNumber, oldMeepCardNumber) {
    const result = await this.postAsync(`CartaoCashlessNominal/AssociarSegundaVia`,
    {
      TagCartaoAnterior: oldMeepCardNumber,
      TagCartaoSegundaVia: newMeepCardNumber
    });
    return result;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/duplicate-meep-card.service.ts